// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".partno-input[data-v-06cf9323] {\n  max-width: 3.5em;\n}\n.itemdesc-input[data-v-06cf9323] {\n  min-width: 20em;\n}\n.money-input[data-v-06cf9323] {\n  max-width: 6.5em;\n}\n.total-input[data-v-06cf9323] {\n  min-width: 6.5em;\n}\n.qty-input[data-v-06cf9323] {\n  max-width: 3.5em;\n}", ""]);
// Exports
module.exports = exports;
